import { render, staticRenderFns } from "./ExpandableCard.vue?vue&type=template&id=51620ea7&scoped=true"
import script from "./ExpandableCard.vue?vue&type=script&lang=js"
export * from "./ExpandableCard.vue?vue&type=script&lang=js"
import style0 from "./ExpandableCard.vue?vue&type=style&index=0&id=51620ea7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51620ea7",
  null
  
)

export default component.exports